import { useState } from 'react';

interface PasswordFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  invalid?: boolean;
  error?: string;
}

export const PasswordField = ({
  label,
  value,
  onChange,
  autoComplete,
  invalid,
  error
}: PasswordFieldProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <label className="block">
      <span className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</span>
      <div className="relative mt-1.5">
        <input
          type={visible ? 'text' : 'password'}
          autoComplete={autoComplete}
          className="input"
          style={{ paddingRight: 96 }}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          aria-invalid={invalid || undefined}
        />
        <button
          type="button"
          className="absolute inset-y-1 right-1 rounded-md px-2 text-xs font-semibold text-brand-600 hover:bg-brand-50"
          aria-pressed={visible}
          aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          onClick={() => setVisible((current) => !current)}
        >
          {visible ? 'Masquer' : 'Afficher'}
        </button>
      </div>
      {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
    </label>
  );
};
